import { atom } from 'jotai';

export const videosRequiringAlignmentVerificationLoadingAtom = atom(false);
videosRequiringAlignmentVerificationLoadingAtom.debugLabel =
  'videosRequiringAlignmentVerificationLoading';

export const videosRequiringAlignmentVerificationAtom = atom([]);
videosRequiringAlignmentVerificationAtom.debugLabel =
  'videosRequiringAlignmentVerification';

export const updateVideoAlignmentAtom = atom(
  null,
  (get, set, { id, isAligned }) => {
    set(
      videosRequiringAlignmentVerificationAtom,
      get(videosRequiringAlignmentVerificationAtom).map((video) =>
        video.id === id ? { ...video, isAligned } : video,
      ),
    );
  },
);

export default { videosRequiringAlignmentVerificationAtom };
